var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { uniqueId } from 'lodash-es';
import styles from './sds-radio-group.lit.scss';
import { SdsRadio } from './sds-radio.lit';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * A radio group component that manages a group of radio buttons.
 *
 * This component provides the following features:
 * - Manages the selection state of radio buttons within the group
 * - Supports both vertical and horizontal layouts
 * - Handles keyboard navigation between radio buttons
 * - Provides error state handling and validation
 * - Maintains proper ARIA attributes for accessibility
 *
 *
 * @slot - Default slot for radio buttons. Only `sds-radio` components are allowed.
 *
 * @fires sds.radio-group.changed - Fired when the selected radio button changes.
 *   Event detail contains the selected radio's value: `{selected: string}`
 * @fires change - Native change event, fired when the selection changes.
 *   Event detail contains the selected radio's value: `{selected: string}`
 */
let SdsRadioGroup = (() => {
    var _SdsRadioGroup_selected_accessor_storage, _SdsRadioGroup_alignment_accessor_storage, _SdsRadioGroup_horizontal_accessor_storage, _SdsRadioGroup_invalid_accessor_storage, _SdsRadioGroup_errorMessage_accessor_storage, _SdsRadioGroup_radios_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-radio-group')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _alignment_decorators;
    let _alignment_initializers = [];
    let _alignment_extraInitializers = [];
    let _horizontal_decorators;
    let _horizontal_initializers = [];
    let _horizontal_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _radios_decorators;
    let _radios_initializers = [];
    let _radios_extraInitializers = [];
    var SdsRadioGroup = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsRadioGroup_selected_accessor_storage.set(this, __runInitializers(this, _selected_initializers, void 0));
            _SdsRadioGroup_alignment_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _alignment_initializers, '')));
            _SdsRadioGroup_horizontal_accessor_storage.set(this, (__runInitializers(this, _alignment_extraInitializers), __runInitializers(this, _horizontal_initializers, false)));
            _SdsRadioGroup_invalid_accessor_storage.set(this, (__runInitializers(this, _horizontal_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsRadioGroup_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsRadioGroup_radios_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _radios_initializers, void 0)));
            /** Unique name for the radio group to ensure proper grouping */
            this.groupName = (__runInitializers(this, _radios_extraInitializers), uniqueId('sds-radio-group'));
            /** Unique ID for error message association */
            this._unique = Math.random().toString(36).slice(2);
        }
        /**
         * The currently selected radio button's value.
         * When set, the radio button with the matching value will be selected.
         *
         * @attr
         */
        get selected() { return __classPrivateFieldGet(this, _SdsRadioGroup_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsRadioGroup_selected_accessor_storage, value, "f"); }
        /**
         * This attribute represents a alignment of underlying radios.
         * @attr
         *
         * @deprecated - Use attr `horizontal` instead
         */
        get alignment() { return __classPrivateFieldGet(this, _SdsRadioGroup_alignment_accessor_storage, "f"); }
        set alignment(value) { __classPrivateFieldSet(this, _SdsRadioGroup_alignment_accessor_storage, value, "f"); }
        /**
         * Controls the layout direction of the radio buttons.
         * When true, radio buttons are arranged horizontally.
         * When false, radio buttons are arranged vertically.
         *
         * @attr
         * @default false
         * @example
         */
        get horizontal() { return __classPrivateFieldGet(this, _SdsRadioGroup_horizontal_accessor_storage, "f"); }
        set horizontal(value) { __classPrivateFieldSet(this, _SdsRadioGroup_horizontal_accessor_storage, value, "f"); }
        /**
         * Indicates whether the radio group is in an invalid state.
         * When true, error styling will be applied and the error message will be displayed.
         *
         * @attr
         * @default false
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsRadioGroup_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsRadioGroup_invalid_accessor_storage, value, "f"); }
        /**
         * Error message to display when the radio group is in an invalid state.
         * Only visible when `invalid` is true.
         *
         * @attr error-message
         * @default ''
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsRadioGroup_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsRadioGroup_errorMessage_accessor_storage, value, "f"); }
        /** Query for all radio buttons assigned to the default slot */
        get radios() { return __classPrivateFieldGet(this, _SdsRadioGroup_radios_accessor_storage, "f"); }
        set radios(value) { __classPrivateFieldSet(this, _SdsRadioGroup_radios_accessor_storage, value, "f"); }
        /**
         * Updates the radio buttons when component properties change.
         * This ensures the radio buttons reflect the current state of the group.
         */
        updated() {
            this.updateRadioButtons();
        }
        /**
         * Renders the radio group component.
         *
         * @returns The rendered HTML template
         */
        render() {
            return html `
            <div
                class="${this.getClasses()}"
                role="radiogroup"
                aria-invalid="${this.invalid}"
                aria-describedby="${this.errorMessage ? `${this._unique}-error` : ''}"
            >
                <slot @slotchange="${() => this.prepareChildren()}"></slot>
                ${this.renderError()}
            </div>
        `;
        }
        /**
         * Renders the error message if the radio group is invalid.
         *
         * @returns The error message template or undefined if no error
         */
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html `
                <sds-error id="${this._unique}-error" message="${this.errorMessage}"></sds-error>
            `;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * Prepares radio buttons when they are added to the group.
         * This method is called when the slot content changes.
         *
         * For each radio button in the group:
         * - Sets a unique name to ensure proper grouping
         * - Syncs the invalid state with the group
         * - Sets the ARIA label with position information (e.g., "Option 1, 1 of 3")
         * - Adds change event listeners
         *
         * @private This method is called internally when slot content changes
         */
        prepareChildren() {
            this.radios.forEach((radio, index) => {
                radio.name = this.groupName;
                radio.invalid = this.invalid;
                const label = radio.label || `Option ${index + 1}`;
                radio.ariaLabel = `${label}, ${index + 1} of ${this.radios.length}`;
                radio.addEventListener(SdsRadio.CHANGED_EVENT, e => this.handleChanged(e));
            });
        }
        /**
         * Updates the state of all radio buttons in the group.
         * Only updates properties that have actually changed to minimize re-renders.
         */
        updateRadioButtons() {
            for (const radio of this.radios) {
                if (radio.checked !== (radio.value === this.selected)) {
                    radio.checked = radio.value === this.selected;
                }
                if (radio.invalid !== this.invalid) {
                    radio.invalid = this.invalid;
                }
            }
        }
        /**
         * Handles radio button change events.
         * Updates the selected value and dispatches change events.
         *
         * @param event - The change event from the radio button
         */
        handleChanged(event) {
            this.selected = event.target.value;
            this.updateRadioButtons();
            this.dispatchEvent(new CustomEvent(SdsRadioGroup.CHANGED_EVENT, {
                detail: { selected: this.selected },
                bubbles: false,
                composed: false,
            }));
            this.dispatchEvent(new CustomEvent(SdsRadioGroup.CHANGE_EVENT, {
                detail: { selected: this.selected },
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Gets the CSS classes to apply to the radio group based on its state.
         *
         * @returns An object mapping class names to boolean values
         */
        getClasses() {
            const isHorizontal = this.horizontal || this.alignment === 'horizontal';
            return classMap({
                'sds-radio-group': true,
                'sds-radio-group--vertical': !isHorizontal,
                'sds-radio-group--horizontal': isHorizontal,
                'sds-radio-group--invalid': this.invalid,
            });
        }
        /**
         * Handles arrow key navigation between radio buttons.
         *
         * @param key - The arrow key that was pressed
         * @param currentRadio - The currently focused radio button
         */
        handleArrowKeyNavigation(key, currentRadio) {
            if (!this.radios || this.radios.length <= 1) {
                return;
            }
            const currentIndex = this.radios.indexOf(currentRadio);
            if (currentIndex === -1) {
                return;
            }
            let nextIndex = currentIndex;
            const isHorizontal = this.horizontal || this.alignment === 'horizontal';
            // Determine the next radio button based on the arrow key and layout direction
            if (isHorizontal) {
                // For horizontal layout, use Left/Right arrows
                if (key === 'ArrowLeft') {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : this.radios.length - 1;
                }
                else if (key === 'ArrowRight') {
                    nextIndex = currentIndex < this.radios.length - 1 ? currentIndex + 1 : 0;
                }
            }
            else {
                // For vertical layout, use Up/Down arrows
                if (key === 'ArrowUp') {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : this.radios.length - 1;
                }
                else if (key === 'ArrowDown') {
                    nextIndex = currentIndex < this.radios.length - 1 ? currentIndex + 1 : 0;
                }
            }
            // Focus and select the next radio button
            const nextRadio = this.radios[nextIndex];
            if (nextRadio && !nextRadio.disabled) {
                nextRadio.focus();
                nextRadio.click();
                nextRadio.setFocused(true);
            }
            else if (nextRadio) {
                // If the next radio is disabled, try to find the next enabled radio
                let foundEnabled = false;
                let searchIndex = nextIndex;
                // Search forward
                for (let i = 0; i < this.radios.length; i++) {
                    searchIndex = (nextIndex + i) % this.radios.length;
                    if (!this.radios[searchIndex].disabled) {
                        this.radios[searchIndex].focus();
                        this.radios[searchIndex].click();
                        this.radios[searchIndex].setFocused(true);
                        foundEnabled = true;
                        break;
                    }
                }
                // If no enabled radio found forward, search backward
                if (!foundEnabled) {
                    for (let i = 1; i < this.radios.length; i++) {
                        searchIndex = (nextIndex - i + this.radios.length) % this.radios.length;
                        if (!this.radios[searchIndex].disabled) {
                            this.radios[searchIndex].focus();
                            this.radios[searchIndex].click();
                            this.radios[searchIndex].setFocused(true);
                            break;
                        }
                    }
                }
            }
        }
    };
    _SdsRadioGroup_selected_accessor_storage = new WeakMap();
    _SdsRadioGroup_alignment_accessor_storage = new WeakMap();
    _SdsRadioGroup_horizontal_accessor_storage = new WeakMap();
    _SdsRadioGroup_invalid_accessor_storage = new WeakMap();
    _SdsRadioGroup_errorMessage_accessor_storage = new WeakMap();
    _SdsRadioGroup_radios_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsRadioGroup");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selected_decorators = [property({ type: String, reflect: true })];
        _alignment_decorators = [property({ type: String })];
        _horizontal_decorators = [property({ type: Boolean, reflect: true })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _radios_decorators = [queryAssignedElements({
                selector: 'sds-radio',
            })];
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _alignment_decorators, { kind: "accessor", name: "alignment", static: false, private: false, access: { has: obj => "alignment" in obj, get: obj => obj.alignment, set: (obj, value) => { obj.alignment = value; } }, metadata: _metadata }, _alignment_initializers, _alignment_extraInitializers);
        __esDecorate(_classThis, null, _horizontal_decorators, { kind: "accessor", name: "horizontal", static: false, private: false, access: { has: obj => "horizontal" in obj, get: obj => obj.horizontal, set: (obj, value) => { obj.horizontal = value; } }, metadata: _metadata }, _horizontal_initializers, _horizontal_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _radios_decorators, { kind: "accessor", name: "radios", static: false, private: false, access: { has: obj => "radios" in obj, get: obj => obj.radios, set: (obj, value) => { obj.radios = value; } }, metadata: _metadata }, _radios_initializers, _radios_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsRadioGroup = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    /** Event name for the custom change event */
    _classThis.CHANGED_EVENT = 'sds.radio-group.changed';
    /** Event name for the native change event */
    _classThis.CHANGE_EVENT = 'change';
    /** Component styles */
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsRadioGroup = _classThis;
})();
export { SdsRadioGroup };
